import React, { useState, useEffect, useRef } from "react";
import { BiLogoPython, BiPlay, BiStop } from "react-icons/bi";
import MonacoEditor from '@monaco-editor/react';
import { useLanguage } from "../../../../Translations/LenguageContext";
import Spinner from "../../../../Components/Spinner";

const CodeEditor = () => {
    const { t } = useLanguage();
    const [codeSnippet, setCodeSnippet] = useState("");
    const [outputTerminal, setOutputTerminal] = useState([]);
    const [language, setLanguage] = useState("python");
    const terminalEndRef = useRef(null);
    const [loading, setLoading] = useState(false)

    const handleEditorChange = (value, event) => {
        setCodeSnippet(value);
    };

    const runCode = async (code, lang) => {
        if (code == "") {
            setOutputTerminal(prev => [...prev, "Please provide a code snippet!"])
            return
        }
        try {
            setLoading(true)
            const response = await fetch(`https://backend.erioon.com/run_code_editor`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ code: code, language: lang }),
            });

            const data = await response.json();
            setOutputTerminal(prev => [...prev, data.output]);
            setLoading(false)
        } catch (error) {
            setLoading(false)
            setOutputTerminal(prev => [...prev, "Error running code."]);
        }
    };

    const handleRunButtonClick = () => {
        runCode(codeSnippet, language);
    };

    const handleLanguageChange = (event) => {
        setLanguage(event.target.value);
    };

    useEffect(() => {
        if (terminalEndRef.current) {
            terminalEndRef.current.scrollIntoView({ behavior: 'smooth' });
        }
    }, [outputTerminal]);

    return (
        <div className="query_editor">
            <div className="sidebar_query">
                <button className="action_sidebar_query_btn" onClick={handleRunButtonClick}>
                    {loading ? (
                        <Spinner loading={loading} />
                    ) : (
                        <>Run <i><BiPlay /></i></>
                    )}
                </button>
                <button className="language_code_input">
                    <BiLogoPython />
                </button>
                {/* <select className="language_code_input" onChange={handleLanguageChange} value={language}>
                    <option value="python">Python</option>
                </select> */}
            </div>
            <div className="editor_input_terminal">
                <MonacoEditor
                    className="query_editor_input"
                    height="100%"
                    width="100%"
                    language={language}
                    onChange={handleEditorChange}
                    defaultValue=""
                />
                <div className="terminal_container">
                    <p className="terminal_title">- This is an Erioon Output terminal - {language}</p>
                    {outputTerminal.map((outputLine, index) => (
                        <p key={index} className="output_lines_terminal">
                            <span className="output_lines_terminal_init">erioon-sys-terminal-output:</span> {outputLine}
                        </p>
                    ))}
                    <div ref={terminalEndRef} />
                </div>
            </div>
        </div>
    );
};

export default CodeEditor;
